import { useStore } from '../../store';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2, XCircle, Info, X } from 'lucide-react';

const ICON = {
  success: <CheckCircle2 size={16} className="text-sage" />,
  error: <XCircle size={16} className="text-rose" />,
  info: <Info size={16} className="text-sky" />,
};

export function Toaster() {
  const toasts = useStore((s) => s.toasts);
  const dismiss = useStore((s) => s.dismissToast);
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-2 pointer-events-none">
      <AnimatePresence>
        {toasts.map((t) => (
          <motion.div
            key={t.id}
            initial={{ opacity: 0, y: 8, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.96 }}
            transition={{ duration: 0.2 }}
            className="surface-frosted px-4 py-3 flex items-center gap-2.5 text-[13px] min-w-[280px] max-w-sm pointer-events-auto"
          >
            {ICON[t.kind]}
            <span className="flex-1 text-ink-800">{t.message}</span>
            <button onClick={() => dismiss(t.id)} className="text-ink-400 hover:text-ink-800">
              <X size={14} />
            </button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
